import { useContext, useEffect } from 'react';
import { setCookie } from 'nookies';
import { useGetSubscriptions } from 'api/subscription';
import { UserContext } from 'context-providers/user-provider';
import { isSubscriptionActive } from 'lib/subscriptions';

// The Cloudflare edge worker mirrors this into a server-set `seed_winback`
// cookie, which Safari doesn't cap at 7 days like script-set cookies.
export const DIGIOH_WINBACK_COOKIE = '_seed_winback';

const ONE_YEAR_IN_SECONDS = 365 * 24 * 60 * 60;

// Digioh targets winback popups off this cookie: 'true' when a logged-in member
// has subscribed before but has nothing active now. Anonymous visitors never
// get it.
export const useDigiohWinback = () => {
  const { userState, isLoadingUser } = useContext(UserContext);
  const { data: subscriptions } = useGetSubscriptions();

  const isLoggedIn = !isLoadingUser && Boolean(userState?.email);

  useEffect(() => {
    if (!isLoggedIn || !subscriptions) return;
    const isWinback =
      subscriptions.length > 0 && !subscriptions.some(isSubscriptionActive);
    setCookie(null, DIGIOH_WINBACK_COOKIE, String(isWinback), {
      maxAge: ONE_YEAR_IN_SECONDS,
      path: '/',
    });
  }, [isLoggedIn, subscriptions]);
};
